

export function Boxes(props: { children: preact.ComponentChildren }) {
  return <div class="boxes">{props.children}</div>
}

export function Box(props: { children: preact.ComponentChildren }) {
  return <div class="box">
    {props.children}
  </div>
}